// extracted by css-extract-rspack-plugin
export default {"Text_0":"StyledInputBlocks-module__Text_0__GrRtv"};